import { useRouter } from 'next/router'

import type { DialogProps } from '@wartek-id/dialog-v1'
import { useToast } from '@wartek-id/toast'

import { assetUrl } from 'utils/url'
import { useAPIPostPelaksanaanAppealRollback } from 'api/kinerja/useAPIKinerja'
import { ConfirmationDialog } from 'app/KinerjaShared/components/ConfirmationDialog'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'

import type { TPelaksanaanAppealableStep } from 'types/kinerja-pelaksanaan'

type RollbackDialogProps = Omit<DialogProps, 'children'> & {
  onSuccess?: () => void
  onCancel?: () => void
  url: string
  step: TPelaksanaanAppealableStep
}

export function RollbackDialog({
  onSuccess,
  onCancel,
  step,
  url,
  isOpen,
  onClose,
  ...dialogProps
}: RollbackDialogProps) {
  const router = useRouter()
  const toast = useToast()

  // ----------------------------------------------------
  // Resolve tipe value
  // ----------------------------------------------------
  const { tipe } = useKinerjaTipe()

  // ----------------------------------------------------
  // Handle mutation
  // ----------------------------------------------------
  const mutationPelaksanaanAppealRollback =
    useAPIPostPelaksanaanAppealRollback()

  const handleConfirm = () => {
    mutationPelaksanaanAppealRollback.mutate(
      { appealState: step, tipe },
      {
        onSuccess: () => {
          onSuccess?.()
          router.push(url)
        },
        onError: () => {
          toast({
            message: 'Gagal lanjut. Coba lagi.',
          })
        },
        onSettled: () => {
          onClose?.()
        },
      }
    )
  }

  return (
    <ConfirmationDialog
      {...dialogProps}
      isOpen={isOpen}
      onClose={onClose as () => void}
      title="Konfirmasi untuk Mengubah Isi"
      description="Jika lanjut ubah, isi akan menjadi draf dan harus dikirim ulang."
      confirmCta="Konfirmasi"
      cancelCta="Kembali"
      hasCloseButton={false}
      topContent={
        <img
          src={assetUrl('/illustrations/img-document-sync-data.png')}
          alt=""
          height={84}
          width={84}
        />
      }
      isLoading={mutationPelaksanaanAppealRollback.isLoading}
      onConfirm={handleConfirm}
      onCancel={onCancel}
    />
  )
}
